export function slugifyChronicle(value = "") {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export const CHRONICLE_ENTITY_TYPES = ["person", "group", "location", "other"];
export const CHRONICLE_ENTITY_ROLE_OPTIONS = ["subject", "actor", "target", "associate", "mentioned", "owner", "host", "primary_location", "location"];
export const CHRONICLE_GROUP_KIND_OPTIONS = ["company", "government", "nonprofit", "campaign", "media", "club", "informal", "other"];
export const CHRONICLE_LOCATION_KIND_OPTIONS = ["address", "venue", "city", "region", "country", "property", "other"];
export const CHRONICLE_ARTIFACT_TYPES = ["webpage", "document", "image", "video"];
export const CHRONICLE_ARTIFACT_ROLE_OPTIONS = ["evidence", "source", "corroboration", "media", "reference", "other"];
export const CHRONICLE_ARTIFACT_SOURCE_KINDS = ["external", "uploaded"];

export function normalizeEntityAliases(value = "") {
  return Array.from(
    new Set(
      String(value || "")
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean)
    )
  );
}

export function normalizeEntityList(value = "") {
  return Array.from(
    new Set(
      String(value || "")
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean)
    )
  );
}

export function buildEntitySlug(displayName = "", fallback = "") {
  const slug = slugifyChronicle(displayName);
  return slug || slugifyChronicle(fallback) || "entity";
}

export function entityTypeLabel(type = "") {
  const normalized = String(type || "").toLowerCase();
  if (!normalized) return "Entity";
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function chronicleEntityRoleLabel(role = "") {
  const normalized = String(role || "").toLowerCase();
  if (!normalized) return "Role";
  if (normalized === "primary_location") return "Primary location";
  return normalized
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function artifactTypeLabel(type = "") {
  const normalized = String(type || "").toLowerCase();
  if (!normalized) return "Artifact";
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function buildArtifactSlug(title = "", fallback = "") {
  const slug = slugifyChronicle(title);
  return slug || slugifyChronicle(fallback) || "artifact";
}

export function sanitizeStorageFileName(name = "file") {
  const original = String(name || "file").trim();
  const dot = original.lastIndexOf(".");
  const base = dot > 0 ? original.slice(0, dot) : original;
  const ext = dot > 0 ? original.slice(dot + 1).toLowerCase() : "";
  const safeBase = slugifyChronicle(base) || "file";
  return ext ? `${safeBase}.${ext}` : safeBase;
}

export function chronicleIdFor(hubSlug = "", chronicleSlug = "") {
  const hub = slugifyChronicle(hubSlug);
  const chronicle = slugifyChronicle(chronicleSlug);
  return `${hub}__${chronicle}`;
}

export function toDateSafe(value) {
  if (!value) return null;
  try {
    if (typeof value.toDate === "function") return value.toDate();
  } catch {
    // noop
  }
  const parsed = value instanceof Date ? value : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatRelativeDate(value) {
  const date = toDateSafe(value);
  if (!date) return "—";
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export function buildChroniclePath(hubSlug, chronicleSlug) {
  return `/h/${encodeURIComponent(hubSlug)}/chronicles/${encodeURIComponent(chronicleSlug)}`;
}

export function buildChronicleShareRoutePath(hubSlug, chronicleSlug) {
  return `/share/h/${encodeURIComponent(hubSlug)}/chronicles/${encodeURIComponent(chronicleSlug)}`;
}

export function buildIncidentPath(hubSlug, chronicleSlug, incidentId) {
  return `${buildChroniclePath(hubSlug, chronicleSlug)}/incidents/${encodeURIComponent(incidentId)}`;
}
